import { Averias } from './../entities/averias.entity';
import { environment } from '../../environments/environment';
import { Explotacion } from '../entities/explotacion.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { AlertService } from '../services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { Contrato } from '../entities/contrato.entity';
import { validate, ValidationError } from 'class-validator';

@Component({
  selector: 'app-averias',
  templateUrl: './averias.component.html'
})
export class AveriasComponent implements OnInit {

  public email: string;
  public politicas: Boolean;
  public consulta: string;
  public contratoCod: number;
  public sinContrato: boolean;
  public direccion: string;

  public tipoAveriaInputError: Boolean;
  public consultaInputError: Boolean;
  public politicasInputError: Boolean;

  public averia: Averias;
  public usuario: UsuarioOnline;

  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;

  public datosExplotacion: Explotacion;
  public avisoEmail: string;
  public condicionesEnvio: string;
  public horario: string;
  public ubicacionOficina: string;
  public parametro: any;
  public id: number;
  public direccionSuministro: string;
  public telefonoexplotacion: string;
  public tipoAveria: string;
  public tipoAveriaDes: string;
  public contratoSelected: Contrato;
  public sinContrato2: boolean;

  public pie: string;

  constructor(private userService: UserService, private sessionService: SessionService,
    private alertService: AlertService, private router: Router) { }

  ngOnInit() {
    this.pie = environment.pie;
    this.clearInputErrors();
    this.politicas = false;
    this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado.' +
      'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
      this.sessionService.datosExplotacion.Email + ' para asegurarse de que recibirá nuestros correos.';
    this.condicionesEnvio = this.sessionService.datosExplotacion.CondicionesEnvio;
    this.horario = this.sessionService.datosExplotacion.Horario;
    this.ubicacionOficina = this.sessionService.datosExplotacion.Domicilio + ' ' + this.sessionService.datosExplotacion.Contacto;

    this.usuario = this.sessionService.usuario;
    this.averia = new Averias();
    this.averia.Nif = this.sessionService.usuario.Login;
    this.averia.Nombre = this.sessionService.usuario.Nombre;
    this.averia.EMail = this.email = this.sessionService.usuario.EMail;
    this.averia.Telefono = this.sessionService.usuario.Telefono1;
    this.averia.Contrato = this.sessionService.contratoSelected.Codigo;
    this.averia.DireccionAveria = this.direccionSuministro;
    this.direccionSuministro = this.sessionService.contratoSelected.InmuebleBO.Direccion;
    // tslint:disable-next-line:max-line-length
    this.telefonoexplotacion = this.sessionService.datosExplotacion.Contacto.substring(2, (this.sessionService.datosExplotacion.Contacto.length - 1));
    this.contratoCod = this.sessionService.contratoSelected.Codigo;
    this.contratoSelected = this.sessionService.contratoSelected;
    this.sinContrato2 = this.sinContrato = this.contratoSelected.Ficticio;

  }

  public enviar() {
    this.clearInputErrors();
    this.averia = new Averias();
    this.averia.Nif = this.sessionService.usuario.Login;
    this.averia.Nombre = this.sessionService.nombre;
    this.averia.EMail = this.sessionService.email;
    this.averia.Telefono = this.sessionService.usuario.Telefono1;
    this.averia.Contrato = this.sinContrato ? null : this.sessionService.contratoSelected.Codigo;
    this.averia.DireccionAveria = this.sinContrato ? this.direccion : this.direccionSuministro;
    this.averia.AveriaEn = this.sinContrato ? 'Incidencia en otra ubicación' : 'Incidencia en mi contrato';
    this.obtenerDescripcionAveria();
    this.averia.TipoAveria = this.tipoAveriaDes;
    this.averia.DescAveria = this.consulta;

    validate(this.averia).then(resultado => {
      if (resultado.length >= 1 || !this.politicas) {
        this.showErrors(resultado);
      } else {
        if (document.getElementById('top') !== null)
          document.getElementById('top').scrollIntoView();
        this.userService.uploadAveria(this.sessionService.explotacion, this.averia)
          .then(
            response => this.AveriaOnSuccess(response),
            response => this.AveriaOnError(response)
          );
      }
    }
    );
  }

  public obtenerDescripcionAveria() {
    switch (this.tipoAveria) {
      case '0': this.tipoAveriaDes = 'Posible salidero interior';
        break;
      case '1': this.tipoAveriaDes = 'Contador parado o averiado';
        break;
      case '2': this.tipoAveriaDes = 'Contador con salidero';
        break;
      case '3': this.tipoAveriaDes = 'Contador con cristal roto';
        break;
      case '4': this.tipoAveriaDes = 'Contador con pantalla empañada';
        break;
      case '5': this.tipoAveriaDes = 'Contador con pantalla en blanco';
        break;
    }
  }

  public sinContrato_change() {
    if (!this.contratoSelected.Ficticio) {
      this.direccionSuministro = '';
      this.sinContrato2 = this.sinContrato;
    }

  }

  public AveriaOnSuccess(response) {
    this.messageCabecera = 'Incidencia enviada correctamente';
    this.typeException = 2;
    this.messageComplet = 'La incidencia se ha enviado correctamente. En breve recibiras una repuesta.';
    this.consulta = '';
    this.tipoAveria = '';
  }

  public AveriaOnError(response) {
    this.messageCabecera = 'Error en el envio de la incidencia';
    this.typeException = 1;
    this.messageComplet = 'El mensaje no se ha enviado correctamente. Intentelo de nuevo en unos minutos o llámenos';
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.direccionSuministro = contratoSelect.InmuebleBO.Direccion;
    this.contratoCod = event.contratoSeleccionado.Codigo;
    this.contratoSelected = contratoSelect;
    this.sinContrato2 = this.sinContrato = contratoSelect.Ficticio;
    this.clearInputErrors();
  }

  public showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'TipoAveria':
          this.tipoAveriaInputError = true;
          break;
        case 'DescAveria':
          this.consultaInputError = true;
      }
    }
    if (!this.politicas) {
      this.politicasInputError = true;
    }
  }

  public clearInputErrors() {
    this.tipoAveriaInputError = false;
    this.consultaInputError = false;
    this.politicasInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  parseStringToInt(val: string) {
    return parseInt(val);
  }

  // MODALS

  _showModalPolitica = false;

  public showModal() {
    return this._showModalPolitica;
  }

  public closeModal() {
    this._showModalPolitica = false;
  }
}
